import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function ChevronLeftIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <g id="chevron_left">
                <path id="vector" d="M15.975 2L17.75 3.775L9.525 12L17.75 20.225L15.975 22L5.975 12L15.975 2Z" />
            </g>
        </SvgIcon>
    );
}
